import { render, staticRenderFns } from "./TableBalance.vue?vue&type=template&id=560a0689&scoped=true"
import script from "./TableBalance.js?vue&type=script&lang=js&external"
export * from "./TableBalance.js?vue&type=script&lang=js&external"
import style0 from "./TableBalance.vue?vue&type=style&index=0&id=560a0689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a0689",
  null
  
)

export default component.exports